import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
// import { setSkill } from "./FlnActivitySlice";

// export const getTeacherBaselineThunk = async (body) => {
//   let response = await api.post("getMasterStudActSkills/", body);
//   return response.data;
// };
// export const getTeacherBaselineThunk = createAsyncThunk(
//   "teacherexam/get",
//   async (data, dispatch) => {
//     let response = await api.get(
//       `getMasterStudActSkills/${data.activityType}/${data.usertype}/${data.language}/${data.program}/${data.clas}/${data.subject}`
//     );
//     // dispatch(setSkill(response));
//     // return response.data;
//   }
// );
// export const getSkills = createAsyncThunk(
//   "getSkills/get",
//   async (data, { dispatch }) => {
//     let response = await api.get(
//       `getMasterStudActSkills/${data.activityType}/${data.usertype}/${data.language}/${data.program}/${data.clas}/${data.subject}`
//     );
//     dispatch(setSkill(response.data));
//     return response.data;
//   }
// );

// <-----------------------------------TopicAPI--------------------------------------->
export const getFlnTopics = async (params) => {
  const { topicId } = params;
  let response = await api.get("getMasterStudActContents" + "/" + topicId);
  console.log(response, "res");
  return response.data;
};

// <-----------------------------------SkillAPI--------------------------------------->

export const getAllContents = async (params) => {
  const { topicId } = params;
  let response = await api.get("getMasterStudActContents" + "/" + topicId);
  console.log(response, "res");
  return response.data;
};

// export const getAllSkillAudio = async (params) => {
//   const { usertype, skillId, language, topicId } = params;
//   let response = await api.get(
//     "getMasterStudActQuiz" + "/" + topicId + "/" + skillId
//   );
//   return response.data;
// };

export const getAllSkillAudio = createAsyncThunk(
  "FlnSkillAudio/Get",
  async (body) => {
    console.log("saveFlnSkillQuiz------->", body);
    let response = await api.post("getStudAudioAssessData", body);
    return response.data;
  }
);

export const saveAllSkillAudio = createAsyncThunk(
  "FlnSkillAudio/Save",
  async (body) => {
    console.log("saveFlnSkillQuiz------->", body);
    let response = await api.patch("evaluateStudAudioAsses", body);
    return response.data;
  }
);

export const saveFlnSkillQuiz = createAsyncThunk(
  "FlnSkillQuiz/Save",
  async (body) => {
    console.log("saveFlnSkillQuiz------->", body);
    let response = await api.post("saveMasterStudActQuiz", body);
    return response.data;
  }
);

export const updateFlnSkillQuiz = createAsyncThunk(
  "FlnSkillQuiz/update",
  async (body) => {
    console.log("saveFlnSkillQuiz------->", body);
    let response = await api.put("updateMasterStudActQuiz", body);
    return response.data;
  }
);

export const deleteFlnSkillQuiz = createAsyncThunk(
  "FlnSkillQuiz/delete",
  async (body) => {
    console.log("delete", body);
    let response = await api.put("deleteMasterStudActQuiz", body);
    return response.data;
  }
);
